import { useEffect, useState } from 'react'
import { applyTheme, followSystemTheme, readTheme, type Theme } from '../lib/theme'

/**
 * Switches the visitor app between dark and light. Shows the mode it
 * switches TO, so the icon reads as an action: a sun in dark mode, a moon in
 * light mode. Ohne Tippen folgt die App dem System (lib/theme.ts); schaltet
 * das System um, zieht der Knopf mit.
 */
export function ThemeToggle({ className = '' }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(readTheme)
  const next: Theme = theme === 'dark' ? 'light' : 'dark'
  useEffect(() => {
    const abmelden = followSystemTheme(setTheme)
    return abmelden
  }, [])

  function toggle() {
    applyTheme(next)
    setTheme(next)
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={next === 'light' ? 'Hellen Modus einschalten' : 'Dunklen Modus einschalten'}
      title={next === 'light' ? 'Heller Modus' : 'Dunkler Modus'}
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-surface-2 text-text transition-colors hover:text-brand focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand ${className}`}
    >
      {next === 'light' ? <SunIcon /> : <MoonIcon />}
    </button>
  )
}

function SunIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
      <path
        d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

function MoonIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
}
